<!--Par défaut les messages les plus récents apparaissant en premier - on peut trier par chacune des colonnes-->
<h2>Messages aux installations</h2>
<app-gmao-spinner *ngIf="!messages"></app-gmao-spinner>
<ng-container *ngIf="messages">
    <p>{{messages.messages_installations.length}} Messages</p>
    <button class="btn btn-outline-info" routerLink="/message/-1">Nouveau</button>
    <div class="table-responsive">
        <table class="table table-bordered table-sm">
            <thead>
                <th (click)="sortby('object')">Objet</th>
                <th (click)="sortby('date_message')">Date de création</th>
                <th (click)="sortby('dest_count')">Destinataire(s)</th>
                <th (click)="sortby('enabled')">Etat</th>
            </thead>
            <tbody>
                <ng-container *ngFor="let message of messages.messages_installations">
                    <tr [routerLink]="['/message',message.id_message]">
                        <td>{{message.object}}</td>
                        <td>{{message.date_message}}</td>
                        <td>{{message.dest_count}}</td>
                        <td [innerHTML]="message.enabled"></td>
                    </tr>
                </ng-container>

            </tbody>
        </table>
    </div>
</ng-container>